import {
  ChangeDetectorRef,
  Component,
  ViewChild,
  ViewContainerRef,
  ViewEncapsulation,
} from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

import { WKWebEmailAddressLinkComponent } from '../wk-web-email-address-link/wk-web-email-address-link.component';
import { WkLinkDocumentComponent } from '../wk-link-document/wk-link-document.component';
import { InsertLinkEvent } from '../../model/custom-models';

@Component({
  selector: 'wk-insert-link.component',
  templateUrl: './wk-insert-link.component.html',
  styleUrls: ['./wk-insert-link.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class WKInsertLinkComponent {
  public contentBlocks = [
    {
      index: 0,
      id: 'webemaillink',
      label: 'ADF_INSERT_LINK.WEB_EMAIL_ADDRESS_TAB',
      component: WKWebEmailAddressLinkComponent,
      linkedCommand: 'insertwebemaillink',
    },
    {
      index: 1,
      id: 'linktoanotherdocument',
      label: 'ADF_INSERT_LINK.LINK_TO_ANOTHER_DOCUMENT_TAB',
      component: WkLinkDocumentComponent,
      linkedCommand: 'insertotherdocumentlink',
    },
    {
      index: 2,
      id: 'linktotextoutsidethisdocument',
      label: 'ADF_INSERT_LINK.LINK_TO_TEXT_OUTSIDE_THIS_DOCUMENT_TAB',
      component: null,
    },
  ];

  private insertLinkEvent: InsertLinkEvent;
  private currentContent: any;
  public selectedIndex = 0;

  @ViewChild('container', { read: ViewContainerRef })
  container: ViewContainerRef;

  constructor(
    private readonly dialogRef: MatDialogRef<WKInsertLinkComponent>,
    private readonly changeDetectorRef: ChangeDetectorRef
  ) {}

  ngAfterViewChecked(): void {
    this.changeDetectorRef.detectChanges();
  }

  ngAfterViewInit() {
    this.currentContent = this.contentBlocks.find(
      (c) => c.id === this.insertLinkEvent.arguments.source.id
    );
    if (this.currentContent) {
      this.setComponent(this.currentContent.component);
    }
    if (this.currentContent) {
      this.selectedIndex = this.currentContent.index;
    }
  }

  public setLinkEvent(insertLinkEvent: InsertLinkEvent) {
    this.insertLinkEvent = insertLinkEvent;
  }

  public checkIfTabEnabled(linkedCommand: string) {
    if (linkedCommand) {
      const command = this.insertLinkEvent?.editor?.commands.get(linkedCommand);
      if (command) {
        return command.isEnabled;
      }
    }
    return false;
  }

  public onTabChange(event) {
    this.selectedIndex = event.index;
    const currentContent = this.contentBlocks.find(
      (c) => c.index === this.selectedIndex
    );
    if (currentContent) {
      this.setComponent(currentContent.component);
    }
  }

  private setComponent(component) {
    if (component) {
      if (this.container.length) {
        this.container.remove(0);
      }

      const componentReference: any = this.container.createComponent(component);

      componentReference.instance.insertLinkEvent = this.insertLinkEvent;
      componentReference.instance.dialogRef = this.dialogRef;
    }
  }

  public closeDialog(): void {
    this.dialogRef.close();
    this.insertLinkEvent.editor?.focus();
  }
}
